import axios from "axios";

export const getJobEmployeeReplacements = callback => {
  var promise = axios({
    method: "get",
    url: "/api/job_employee_replacements"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
